<script lang="ts">
  import type { SalesRep } from "@shared/types/SalesRep";
  import Icon from "@shared/svelte/Components/Icon.svelte";
  import UIRouterLink from "@shared/svelte/Components/UIRouterLink.svelte";
  import formatPhone from "@shared/filters/phone.js";

  export let deleteRep: (id: number, rep: SalesRep, skipConfirm: boolean) => void;
  export let editSalesRep: (rep: SalesRep) => void;
  export let salesRep: SalesRep;
  export let distributorId: number;
  export let hideDeleteButton: boolean = false;
  export let hideEditButton: boolean = false;

  let name: string;
  let email: string | null;
  let phone: string | null;
  let hasEmailNotificationErrors: boolean;
  let hasPhoneNotificationErrors: boolean;

  $: {
    if (salesRep.retailer_sales_rep_contact) {
      name = salesRep.retailer_sales_rep_contact.full_name;
      email = salesRep.retailer_sales_rep_contact.sanitized_email;
      phone = salesRep.retailer_sales_rep_contact.sanitized_phone;
    } else {
      name = salesRep.name;
      email = salesRep.contact_email;
      phone = salesRep.contact_phone;
    }
    hasEmailNotificationErrors = salesRep?.has_email_notification_errors;
    hasPhoneNotificationErrors = salesRep?.has_phone_notification_errors;
  }

  let componentWidth = null;
  $: responsiveState = componentWidth < 500;

</script>

<style>
  div.distributor-sales-rep-list:last-of-type {
    border-bottom: unset;
  }

  div.distributor-sales-rep-list {
    overflow: visible;
    word-break: break-all;
  }

</style>

<div
  class="fizz-flex-row-responsive fizz-card-padded fizz-border-bottom distributor-sales-rep-list"
  id={`sales_rep_${salesRep.id}`}
>
  <div
    bind:clientWidth={componentWidth}
    class="fizz-flex-item fizz-flex-row-4-responsive fizz-align-content-start"
  >
    <div class="fizz-flex-row-8-responsive fizz-stack-8 fizz-flex-item fizz-align-content-start">
      <div class="fizz-flex-item fizz-flex-row fizz-space-between">
        {name}
      </div>
      <div class="fizz-flex-item">
        {#if email}
          {email}
          {#if hasEmailNotificationErrors && !salesRep.customer_service}
            <div class="fizz-flex-row fizz-text-urgent">
              <Icon
                type="Info"
                height="14"
                width="14"
                extraClassNames="fizz-inline-block fizz-inline-4"
              />
              <span>Enter a valid email</span>
            </div>
          {/if}
        {/if}
      </div>
      <div class="fizz-flex-item">
        {#if phone}
          <a href={`tel:${phone}`} style="text-decoration: unset; color: #000;">
            {formatPhone(phone)}
          </a>
          {#if hasPhoneNotificationErrors && !salesRep.customer_service}
            <div class="fizz-flex-row fizz-text-urgent">
              <Icon
                type="Info"
                height="14"
                width="14"
                extraClassNames="fizz-inline-block fizz-inline-4"
              />
              <span>Enter a valid number</span>
            </div>
          {/if}
        {/if}
      </div>
    </div>
    <div class="fizz-flex-row" style="min-height: 20px;">
      {#if !salesRep.customer_service}
        <div class="fizz-tooltip-container">
          <div
            id={`message_sales_rep_${salesRep.id}`}
            class="fizz-tooltip-trigger"
            aria-describedby="tooltip-message-rep"
          >
            <UIRouterLink
              id={`message_sales_rep_${salesRep.id}_link`}
              stateName={"layout.messaging_center_index"}
              params={{ salesRepId: salesRep.id }}
              classes={"fizz-text-brand"}
            >
              <Icon
                type="Message"
                height="14"
                width="14"
                extraClassNames="cursor-pointer vertical-align-middle fizz-text-brand"
              />
            </UIRouterLink>
          </div>
          <div
            class="fizz-tooltip fizz-tooltip-top fizz-tooltip-center fizz-stack-8"
            role="tooltip"
            id="tooltip-message-rep"
          >
            Message
          </div>
        </div>
      {/if}
      {#if !hideEditButton}
        <div class="fizz-tooltip-container">
          <div
            id={`edit_sales_rep_${salesRep.id}`}
            class="fizz-tooltip-trigger"
            aria-describedby="tooltip-edit-rep"
          >
            <Icon
              type="Edit"
              height="14"
              width="14"
              extraClassNames="cursor-pointer vertical-align-middle fizz-text-brand"
              onPress={() => editSalesRep(salesRep)}
            />
          </div>
          <div
            class="fizz-tooltip fizz-tooltip-top fizz-tooltip-center fizz-stack-8"
            role="tooltip"
            id="tooltip-edit-rep"
          >
            Edit
          </div>
        </div>
      {/if}
      {#if !hideDeleteButton}
        <div class="fizz-tooltip-container">
          <div
            id={`delete_sales_rep_${salesRep.id}`}
            class="fizz-tooltip-trigger"
            aria-describedby="tooltip-delete-rep"
          >
            <Icon
              type="Trash"
              height="14"
              width="14"
              extraClassNames="cursor-pointer vertical-align-middle fizz-text-brand"
              fill={"#002b48"}
              onPress={() => deleteRep(distributorId, salesRep, false)}
            />
          </div>
          <div
            class="fizz-tooltip fizz-tooltip-top fizz-tooltip-center fizz-stack-8"
            role="tooltip"
            id="tooltip-delete-rep"
          >
            Delete
          </div>
        </div>
      {/if}
    </div>
  </div>
</div>
